import { Dayjs, OpUnitType } from 'dayjs'

import { earliest } from './earliest'
import { isSameOrBefore } from './isSameOrBefore'
import { latest } from './latest'

type DateInterval = { startDate: Dayjs; endDate: Dayjs }

/**
 * Gets whether the specified interval contains the specified date.
 * @param interval The enddate is inclusive.
 */
function contains(interval: DateInterval, date: Dayjs, unit?: OpUnitType) {
    return isSameOrBefore(interval.startDate, date, unit) && isSameOrBefore(date, interval.endDate, unit)
}
/**
 * Gets whether the first interval completeless encompasses the second.
 * @param interval The enddate is inclusive.
 * @param subinterval The enddate is inclusive.
 */
export function containsInterval(interval: DateInterval, subinterval: DateInterval, unit?: OpUnitType) {
    return contains(interval, subinterval.startDate, unit) && contains(interval, subinterval.endDate, unit)
}

export function overlaps(interval1: DateInterval, interval2: DateInterval, unit?: OpUnitType) {
    return (
        contains(interval1, interval2.startDate, unit) ||
        contains(interval1, interval2.endDate, unit) ||
        contains(interval2, interval1.startDate, unit) ||
        contains(interval2, interval1.endDate, unit)
    )
}
function mergeGivenOverlap(interval1: DateInterval, interval2: DateInterval) {
    return { startDate: earliest(interval1.startDate, interval2.startDate), endDate: latest(interval1.endDate, interval2.endDate) }
}

/**
 * @param intervals Assumed to be sorted by startDate
 */
export function toDisjointIntervals(intervals: DateInterval[], unit?: OpUnitType) {
    if (intervals.length === 0) return []
    if (intervals.length === 1) return intervals

    const result = [intervals[0]!]

    for (const interval of intervals) {
        const current = result[result.length - 1]
        if (current && overlaps(current, interval, unit)) {
            result[result.length - 1] = mergeGivenOverlap(current, interval)
        } else {
            result.push(interval)
        }
    }

    return result
}
